import { trackClick } from "@/services/d1Service";

export const trackElfEvent = async (identifier: string) => {
  try {
    await trackClick({ cta_identifier: identifier });
  } catch (error) {
    console.error("Failed to track elf event:", identifier, error);
  }
};

